import { environment } from '@environment/environments';

export const LOGIN_URL = `${environment.baseUrl}/pahdp-user/v1/login`;
export const FORGOT_PASSWORD_URL = `${environment.baseUrl}/pahdp-user/v1/forgot-password`;
export const CONFIRM_FORGOT_PASSWORD_URL = `${environment.baseUrl}/pahdp-user/v1/confirm-forgot-password`;
export const FORCE_CHANGE_PASSWORD_URL = `${environment.baseUrl}/pahdp-user/v1/force-change-password`;
